import React from "react"
import Components from '../../../components'
import Client from "../../../services"

class CreateCourse extends React.Component{
    state = {
        symbol: "",
        title: "",
        
    }

    handleChange = (e) => {
        e.preventDefault()
        const {name, value} = e.target

        this.setState({
            [name]: value
        })
    }

    handleSubmit = async (e) => {
        e.preventDefault()
        const { title, description, nLevel, duration, cost, startingFrom, symbol} = this.state
        const payload = {
            title, symbol
        }
       
        const {success, data, message} = await Client.api.post('/admin/online-course', payload)
        if (success){
            this.props.history.replace('/admin/online-course/list')
        }else{
            Client.alert.fire({
                title: "Failed",
                body: message || "Failed to create the batch.",
                confirmButton: true
            })
        }
    }

    render(){
        

        return <div className="new-student-batch">
            <h2>Initialize New Course</h2>
            <Components.forms.SimpleForm>
                <table>
                    <tbody>
                        <tr>
                            <td>Course Code</td>
                            <td><Components.input.TextInput placeholder="Symbol" name="symbol"  value={this.state.symbol}  onChange={this.handleChange}/></td>
                        </tr>
                        <tr>
                            <td>Title</td>
                            <td><Components.input.TextInput placeholder="Title" name="title"  value={this.state.title}  onChange={this.handleChange}/></td>
                        </tr>
                    </tbody>
                </table>
                <Components.buttons.FlatButton onClick={this.handleSubmit}>Submit</Components.buttons.FlatButton>
                
            </Components.forms.SimpleForm>
        </div>
    }
}

export default CreateCourse